module.exports = __webpack_public_path__ + "img/search.e601b341.svg";